// extracted by mini-css-extract-plugin
module.exports = {"tableFrame":"PricingPackagesTable_tableFrame_1IdKJ","noValue":"PricingPackagesTable_noValue_2t8gx"};